import React, { useEffect, useRef } from 'react'
import {
  PieChart as ChartistPieChart,
  PieChartData,
  PieChartOptions,
  ResponsiveOptions,
} from 'chartist'

export interface PieChartProps {
  data: PieChartData
  options?: PieChartOptions
  className?: string
  responsiveOptions?: ResponsiveOptions
  onDraw?: (d: any) => void
}

export const PieChart: React.FC<PieChartProps> = ({
  className = '',
  data,
  options = {},
  responsiveOptions = [],
  onDraw,
}) => {
  const chartRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const chartist = new ChartistPieChart(
      chartRef.current,
      data,
      options,
      responsiveOptions,
    )

    if (onDraw) {
      chartist.on('draw', onDraw)
    }
  }, [])

  return <div className={className} ref={chartRef} />
}
